import { combineReducers } from "redux";
import booksReducer from "./books/reducer";
import { updateBookReducer } from "./bookUpdate/bookUpdate";
import filterReducer from "./filter/reducer";

const rootReducer = combineReducers({
  books: booksReducer,
  filters: filterReducer,
  bookUpdate: updateBookReducer,
});

export default rootReducer;
